module.exports = __webpack_public_path__ + "img/bucket-fill.f56c99f3.svg";